

/* **************************************************** Finishing Shedule Accessory Name */
export interface FSColorThemeType {
    id: number;
    status: number;
    color_theme_name: string;
    color_theme_code: string;
    created_by: number | null;

}

export const mapFSColorThemeType = (data: any): FSColorThemeType => {
    if (!data) {
        throw new Error("Invalid Data");
    }

    const res: FSColorThemeType = {
        id: data.id,
        status: data.status,
        color_theme_name: data.color_theme_name,
        color_theme_code: data.color_theme_code,
        created_by: data.created_by || null,
     
    };

    return res;
};

export const mapFSColorThemeTypes = (data: any[]): FSColorThemeType[] => {
    if (!Array.isArray(data)) {
        throw new Error("Invalid Data");
    }

    return data.map(mapFSColorThemeType);
};
